import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Family } from 'src/clients/hooks/useFamily';
import DrawerFlow, { DrawerFlowStep } from 'src/UI/drawer-flow/DrawerFlow';
import SelectClientOrFamilyStep from 'src/UI/drawer-flow/SelectClientOrFamilyStep';
import { Client } from 'src/users';
import FactFindProgressSvg from './assets/fact-find-progress.svg?react';
import GenerateOptionsStep from 'src/fact-find/steps/GenerateOptionsStep';

type FactFindFlowProps = {
  opened: boolean;
  close: () => void;
};

type FactFindData = {
  client?: Client;
  family?: Family;
  selectionType?: 'client' | 'family';
  includeSensitiveFields?: boolean;
};

const initialData: FactFindData = {
  client: undefined,
  family: undefined,
  selectionType: 'client',
  includeSensitiveFields: false,
};

const steps: DrawerFlowStep<FactFindData>[] = [
  {
    title: 'Select client',
    showClientName: false,
    screens: [
      {
        component: SelectClientOrFamilyStep,
        renderProgress: () => <FactFindProgressSvg />,
      },
    ],
  },
  {
    title: 'Generate fact find',
    showClientName: true,
    screens: [
      {
        component: GenerateOptionsStep,
        renderProgress: () => <FactFindProgressSvg />,
      },
    ],
  },
];

export default function FactFindFlow({ opened, close }: FactFindFlowProps) {
  const [data, setData] = useState<FactFindData>(initialData);
  const navigate = useNavigate();

  const onSuccess = useCallback(
    (data: FactFindData) => {
      if (data.selectionType === 'client' && data.client) {
        navigate(`/client/${data.client.id}/document/fact-finds`);
      } else if (data.selectionType === 'family' && data.family) {
        navigate(`/client/${data.family.mainFamilyMember.clientId}/document/fact-finds`);
      }
    },
    [navigate],
  );

  return (
    <DrawerFlow
      opened={opened}
      close={close}
      title="Fact find"
      steps={steps}
      initialData={initialData}
      data={data}
      setData={setData}
      onSuccess={onSuccess}
    />
  );
}
